document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function updateSelectedLabel(group) {
    const labelEl = group.querySelector('[data-filter-selected-label]');
    if (!labelEl) return;
    const checkedSwatch = group.querySelector('input:checked ~ .color-swatch--filter');
    labelEl.textContent = checkedSwatch ? ' - ' + checkedSwatch.getAttribute('data-swatch-name') : '';
  }

  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest('.color-swatch--filter');
    if (!swatch) return;
    const group = swatch.closest('.collection-sidebar__group');
    const labelEl = group ? group.querySelector('[data-filter-selected-label]') : null;
    if (!labelEl) return;
    labelEl.textContent = ' - ' + swatch.getAttribute('data-swatch-name');
  });

  document.addEventListener('mouseout', (event) => {
    const swatch = event.target.closest('.color-swatch--filter');
    if (!swatch) return;
    const group = swatch.closest('.collection-sidebar__group');
    if (group) updateSelectedLabel(group);
  });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input.matches && input.matches('.tag-list input[type="checkbox"]'))) return;
    const group = input.closest('.collection-sidebar__group');
    if (group) updateSelectedLabel(group);
  });
});
